import type { Locale } from '../i18n/translations'
import { EXCHANGE_RATES } from '../store/useStore'

interface CurrencyInfo {
  code: string
  symbol: string
  rate: number // JPY per 1 unit of this currency
  label: string
}

const CURRENCY_MAP: Record<Locale, CurrencyInfo> = {
  ja: { code: 'JPY', symbol: '¥', rate: 1, label: '日本円' },
  en: { code: 'USD', symbol: '$', rate: EXCHANGE_RATES.USD_JPY, label: 'USD' },
  zh: { code: 'CNY', symbol: '¥', rate: EXCHANGE_RATES.CNY_JPY, label: '人民元' },
  // #2115 繁体字のお客様は台湾が中心なので台湾ドルで出す (香港ドルではない)
  'zh-TW': { code: 'TWD', symbol: 'NT$', rate: EXCHANGE_RATES.TWD_JPY, label: 'TWD' },
  ko: { code: 'KRW', symbol: '₩', rate: EXCHANGE_RATES.KRW_JPY, label: 'KRW' },
  fr: { code: 'EUR', symbol: '€', rate: EXCHANGE_RATES.EUR_JPY, label: 'EUR' },
  de: { code: 'EUR', symbol: '€', rate: EXCHANGE_RATES.EUR_JPY, label: 'EUR' },
  es: { code: 'EUR', symbol: '€', rate: EXCHANGE_RATES.EUR_JPY, label: 'EUR' },
  th: { code: 'THB', symbol: '฿', rate: 4.15, label: 'THB' },
  vi: { code: 'VND', symbol: '₫', rate: 0.006, label: 'VND' },
  id: { code: 'IDR', symbol: 'Rp', rate: 0.0094, label: 'IDR' },
}

export function getCurrency(locale: Locale): CurrencyInfo {
  return CURRENCY_MAP[locale] ?? CURRENCY_MAP.en
}

export function jpyToHomeCurrency(jpyAmount: number, locale: Locale): number {
  const currency = getCurrency(locale)
  if (currency.code === 'JPY') return jpyAmount
  return +(jpyAmount / currency.rate).toFixed(2)
}

export function formatHomeCurrency(jpyAmount: number, locale: Locale): string {
  const currency = getCurrency(locale)
  if (currency.code === 'JPY') return ''
  const converted = jpyToHomeCurrency(jpyAmount, locale)
  return `≈ ${currency.symbol}${converted.toLocaleString()} ${currency.label}`
}
